export const PERIOD_SELECT = [
    {
        id: 1,
        title: '제한 없음',
        name: 'unlimit',
    },
    {
        id: 2,
        title: '미',
        name: 'unexpose',
    },
    {
        id: 3,
        title: '기간 설정 ',
        name: 'period',
    },
]